import { siteCall } from "../utils/WebCall";
import urls from '../utils/urls'


export const getStatsMeetings = async(successCallback, errorCallback) => {
  return siteCall({
      url: urls.stats_meetings_url + "/get-all",
      method: "GET",
      body: {},
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
}


export const updateMeetingUsage = async(params, successCallback, errorCallback) => {
  return siteCall({
      url: urls.stats_meetings_url + "/update-meeting-usage",
      method: "PATCH",
      body: JSON.stringify(params),
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
}